import { createSlice } from '@reduxjs/toolkit';

import { INITIAL_LIST_PARAMS } from 'config';
import { GroupState } from 'types/group';

const initialState: GroupState = {
  isLoading: false,
  groupList: {},
  groupListParams: INITIAL_LIST_PARAMS,
  courseList: {},
  courseListParams: INITIAL_LIST_PARAMS,
  group: undefined,
};

const slice = createSlice({
  name: 'group',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    resetError(state) {
      state.error = undefined;
    },

    getGroupListSuccess(state, action) {
      state.groupList = action.payload;
    },

    getGroupSuccess(state, action) {
      state.isLoading = false;
      state.group = action.payload;
    },

    setGroupListParams(state, action) {
      state.groupListParams = action.payload;
    },

    clearGroup(state) {
      state.group = undefined;
    },

    getCourseListSuccess(state, action) {
      state.isLoading = false;
      state.courseList = action.payload;
    },

    setCourseListParams(state, action) {
      state.courseListParams = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  hasError,
  resetError,
  setGroupListParams,
  getGroupListSuccess,
  getGroupSuccess,
  clearGroup,
  getCourseListSuccess,
  setCourseListParams,
} = slice.actions;
